import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "61b68bd0-402e-4fbd-beb8-aa0493349608",
    options: { imageUrl: `${config.ASSETS_URL}/05/26/task/task-1-item-1.png` },
  },
  {
    id: "bbd4de66-0164-4dbd-8339-81707aab29ef",
    options: { imageUrl: `${config.ASSETS_URL}/05/26/task/task-1-item-2.png` },
  },
  {
    id: "39ee6af9-117f-4e60-80af-d80b90205086",
    options: { imageUrl: `${config.ASSETS_URL}/05/26/task/task-1-item-3.png` },
  },
  {
    id: "de53aad7-728f-417e-be83-3e64951bc7bf",
    options: { imageUrl: `${config.ASSETS_URL}/05/26/task/task-1-item-4.png` },
  },
];

export const task: Task = {
  id: "4ebb3a4a-a35f-40a6-9cd6-141e73f86887",
  solutionType: "order",
  type: "orderImages",
  options: {
    imageViewType: "contain",
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "61b68bd0-402e-4fbd-beb8-aa0493349608",
    "bbd4de66-0164-4dbd-8339-81707aab29ef",
    "39ee6af9-117f-4e60-80af-d80b90205086",
    "de53aad7-728f-417e-be83-3e64951bc7bf",
  ],
};
